module.exports = __webpack_public_path__ + "img/CheckExplanations.b19fb8f8.png";